import { lazy, } from 'react';

export const portraitGridComponent = lazy(() => import('./components/Grid/Portrait'));
export const desktopStandardGridComponent = lazy(() => import('./components/Grid/Desktop/Standard'));
export const desktopWideGridComponent = lazy(() => import('./components/Grid/Desktop/Wide'));
